const concatMap = (arr, fn) => [].concat(...arr.map(fn));
/**
 * Add the passed element between each elment of the original array
 * @param originArray source array
 * @param elementToInsert elment to insert
 */
export const intersperse = (originArray, elementToInsert) => concatMap(originArray, (x) => [elementToInsert, x]).slice(1);
export const getByValue = (map, searchValue) => {
    for (const [key, value] of map.entries()) {
        if (value === searchValue) {
            return key;
        }
    }
    return undefined;
};
export const moveElementsToBeginning = (originArray, elementsToMove) => {
    for (const element of elementsToMove) {
        const foundIdx = originArray.findIndex((el) => el === element);
        if (foundIdx !== -1) {
            originArray.splice(foundIdx, 1);
            originArray.unshift(element);
        }
    }
    return originArray;
};
